import Vue from "vue";

const vuemoment = require('vue-moment')
const moment = require('moment')
require('moment/locale/pt-br')
 
Vue.use(vuemoment, {
  moment
})